<template>
  <div>
    <v-text-field
      :value="infoText"
      readonly
      @mouseup="onClick"
    />
    <v-dialog :persistent="true" v-model="selected" max-width="30%" eager>
      <v-card>
        <v-card-text>
          <v-container
            style="max-height: 600px"
            class="overflow-y-auto"
          >
            <div
              :class="getMachineElementDisplayClass(machine)"
              v-for="machine in fullMachineList" :key="machine.id"
            >
              <v-checkbox
                readonly
                :label="machine.displayName"
                :input-value="isMachineSelected(machine)"
                v-on:click.stop="() => toggleMachine(machine)"
              />
            </div>
          </v-container>

        </v-card-text>

        <v-card-actions>
          <v-btn color="default" text @click="clear">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn color="primary" text @click="selected = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  name: 'MachinesFilter',
  components: {
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
  },
  computed: {
    ...mapState(['machines']),
    fullMachineList() {
      return this.createFullMachineList();
    },
    infoText() {
      if (!this.selectedMachines || this.selectedMachines.length <= 0) {
        return 'Suche...';
      }

      let result = '';
      let first = true;

      this.selectedMachines.forEach(m => {
        if (first) {
          result = `${m.displayName}`;
          first = false;
        } else {
          result = `, ${m.displayName}`;
        }
      })

      return result.length > 30 ? `${result.substring(0, 27)}...` : result;
    }
  },
  mounted() {
  },
  methods: {
    toggleMachine(m) {
      const toggleIndex = this.selectedMachines.findIndex(x => x.id === m.id);

      if (toggleIndex >= 0) {
          this.selectedMachines.splice(toggleIndex, 1);
        } else {
          this.selectedMachines.push(m);
        }

      this.$emit('changed', this.selectedMachines.map(x => x.id));
    },
    getMachineElementDisplayClass(m) {
      if (!m.isTool) {
        return 'machine-item';
      }

      return 'machine-item machine-item-indent';
    },
    isMachineSelected(m) {
      return this.selectedMachines.some(x => x.id === m.id);
    },
    createFullMachineList() {
      const machinesAndTools = [];
      const toolsThatCanBeUsedWithAnyMachine = [];

      this.machines.forEach(m => {
        if (m.isToolThatCanBeUsedWithAnyMachine) {
          toolsThatCanBeUsedWithAnyMachine.push(m);
        } else {
          machinesAndTools.push({
            ...m,
            isTool: false,
            parentId: null,
          });
          m.tools.forEach(t => {
            machinesAndTools.push({
              ...t,
              isTool: true,
              parentId: m.id,
            });
          });
        }
      });

      return [
        ...machinesAndTools,
        ...toolsThatCanBeUsedWithAnyMachine,
      ];
    },
    clear() {
      this.selectedMachines = [];
      this.$emit('changed', null);
    },
    onClick() {
      if (this.disabled) {
        return;
      }

      if (!this.selected) {
        this.selected = true;
      }
    },
  },
  data() {
    return {
      selected: false,
      selectedMachines: [],
    };
  },
};
</script>

<style>
  .machine-container {
    height: 600px;
    max-height: 600px;
    overflow-y: scroll
  }
  .machine-item {
    border-bottom: 1px solid #f3f3f3;
  }
  .machine-item-indent {
    padding-left: 60px;
  }
</style>
